import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AuthControllerService } from './api/authController.service';
import { BonificheControllerService } from './api/bonificheController.service';
import { ComuneControllerService } from './api/comuneController.service';
import { ConfigurationControllerService } from './api/configurationController.service';
import { ImportControllerService } from './api/importController.service';
import { NegoziControllerService } from './api/negoziController.service';
import { PraticheControllerService } from './api/praticheController.service';
import { PraticheEsercentiControllerService } from './api/praticheEsercentiController.service';
import { PublicControllerService } from './api/publicController.service';
import { RendicontazioniControllerService } from './api/rendicontazioniController.service';
import { SuperadminControllerService } from './api/superadminController.service';
import { TipoPraticaControllerService } from './api/tipoPraticaController.service';
import { TransazioniControllerService } from './api/transazioniController.service';
import { UserControllerService } from './api/userController.service';
import { VoucherControllerService } from './api/voucherController.service';
import { WhatsappControllerService } from './api/whatsappController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AuthControllerService,
    BonificheControllerService,
    ComuneControllerService,
    ConfigurationControllerService,
    ImportControllerService,
    NegoziControllerService,
    PraticheControllerService,
    PraticheEsercentiControllerService,
    PublicControllerService,
    RendicontazioniControllerService,
    SuperadminControllerService,
    TipoPraticaControllerService,
    TransazioniControllerService,
    UserControllerService,
    VoucherControllerService,
    WhatsappControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
